import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=231a543f&scoped=true"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"
import style0 from "./Branding.vue?vue&type=style&index=0&id=231a543f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a543f",
  null
  
)

export default component.exports